import { useEffect } from 'react';

const SITE = 'https://www.nettoplus.be';

/**
 * Renseigne le titre, la description, l'URL canonique, l'image de partage et,
 * si fourni, un bloc de données structurées (JSON-LD) propres à la page
 * courante. Sans cela, toutes les pages héritaient de la canonique unique
 * définie dans index.html (« / »), ce qui faisait passer les pages
 * services/zones pour des doublons de l'accueil aux yeux de Google.
 *
 * `jsonLd` : objet (ou @graph) injecté dans un <script type="application/ld+json">
 * dédié, retiré au changement de page. Le prérendu SEO le capture dans le HTML.
 */
export const useSeo = ({ title, description, path, image, jsonLd } = {}) => {
  useEffect(() => {
    if (title) document.title = title;

    const majMeta = (attr, cle, valeur) => {
      if (valeur == null) return;
      let el = document.head.querySelector(`meta[${attr}="${cle}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, cle);
        document.head.appendChild(el);
      }
      el.setAttribute('content', valeur);
    };

    if (description) majMeta('name', 'description', description);

    const url = SITE + (path || window.location.pathname);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement('link');
      canon.setAttribute('rel', 'canonical');
      document.head.appendChild(canon);
    }
    canon.setAttribute('href', url);

    majMeta('property', 'og:url', url);
    if (title) majMeta('property', 'og:title', title);
    if (description) majMeta('property', 'og:description', description);
    if (image) {
      majMeta('property', 'og:image', image);
      majMeta('name', 'twitter:image', image);
    }

    // Données structurées propres à la page (JSON-LD).
    const LD_ID = 'ld-page';
    let script = document.getElementById(LD_ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = LD_ID;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      const el = document.getElementById(LD_ID);
      if (el) el.remove();
    };
  }, [title, description, path, image, JSON.stringify(jsonLd)]);
};

export default useSeo;
